export var SaveActionEnum;
(function (SaveActionEnum) {
    SaveActionEnum[SaveActionEnum["Save"] = 0] = "Save";
    SaveActionEnum[SaveActionEnum["UnSave"] = 1] = "UnSave";
    SaveActionEnum[SaveActionEnum["Cancel"] = 2] = "Cancel";
})(SaveActionEnum || (SaveActionEnum = {}));
